import { combineReducers } from '@reduxjs/toolkit'

import agentProfileReducer, { initialState as initialAgentProfile } from './agent-profile'
import alertDialogReducer, { initialState as initialAlertDialog } from './alert-dialog'
import publicListingReducer, { initialState as initialPublicListing } from './public-listing'
import publicMessagingReducer, { initialState as initialPublicMessaging } from './public-messaging'
import toastReducer, { initialState as initialToast } from './toast'
import userReducer, { initialState as initialUser } from './users'

const rootReducer = combineReducers({
  ...agentProfileReducer,
  ...userReducer,
  ...publicListingReducer,
  ...toastReducer,
  ...publicMessagingReducer,
  ...alertDialogReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export const initialStoreState: RootState = {
  agentProfile: initialAgentProfile,
  users: initialUser,
  publicListing: initialPublicListing,
  toast: initialToast,
  publicMessaging: initialPublicMessaging,
  alertDialog: initialAlertDialog,
}

export default rootReducer
